module.exports = __webpack_public_path__ + "static/service-banner-date-range-0516eb3fcbb0b2dbac716107c9cd3b57.jpeg";